import {Country} from "../../api/trialAPI"

export class CountrySelector {
    static getInitCountry(countries: Country[]): Country {
        return countries.find((item) => item.acronym === "US") || countries[0]
    }
}
